import React from 'react';
import BaseSvg from './BaseSvg';
import { IconProps } from './icon';

export default function IconSvg(props: IconProps): React.ReactElement {
  const {
    children,
    description,
    dmId,
    id,
    fill,
    pointerEvents = 'none',
    size,
    title,
    ...otherProps
  } = props;

  return (
    <BaseSvg
      data-designsystem
      description={description}
      id={id}
      dmId={dmId}
      fill={fill}
      pointerEvents={pointerEvents}
      size={size}
      title={title}
      viewBox="0 0 24 24"
      {...otherProps}>
      {children}
    </BaseSvg>
  );
}
